<template>
  <div id="product-center">

    <page-head :subnav_show="false" :change_color="true"></page-head>

    <!-- ======= Hero Section ======= -->
    <div id="product-hero" data-aos="zoom-out" data-aos-delay="100"></div>

    <div class="container mt-4" data-aos="fade-up">

      <div class="section-title">
        <h2>产品中心</h2>
        <p>PRODUCT</p>
      </div>
      <el-row class="el-row">
                <el-col class="type">
                    <div class="left-sidebar">
                        <div>
                            <el-tabs v-model="typeflag" @tab-click="changetype">
                                <el-tab-pane label="产品类别" name="category"></el-tab-pane>
                                <el-tab-pane label="行业类别" name="industry"></el-tab-pane>
                            </el-tabs>
                        </div>
                        <el-tree
                            v-if="'category' === typeflag"
                            :data="categoryList"
                            node-key="id"
                            :props="{children: 'children', label:'categoryName'}"
                            icon-class=" ">
                                <span class="custom-tree-node" slot-scope="{ node, data }">
                                    <i style="width:12px;display:inline-block;padding-bottom: 2px;vertical-align: middle;" v-if="data.children&&data.children.length===0"></i>
                                    <i style="font-size:12px;padding-bottom: 2px;vertical-align: middle;" v-if="data.children&&data.children.length>0&&!node.expanded" class="el-icon-arrow-right"/>
                                    <i style="font-size:12px;padding-bottom: 2px;vertical-align: middle;" v-if="node.expanded" class="el-icon-arrow-down"/>
                                    <span style="margin-left: 5px;width:100%;display:inline-block;font-size:14px" :title='data.categoryName || "-"' class="tree-node-label" :class="treeNodeCssActive(data.id)" @click.stop.prevent="clickTreeNode(data, $event)" @mousedown.stop>{{data.categoryName}}</span>
                                </span>
                        </el-tree>
                        <el-tree
                            v-if="'industry' === typeflag"
                            :data="industryList"
                            node-key="value"
                            :props="{children: 'children', label:'label'}"
                            icon-class=" ">
                                <span class="custom-tree-node" slot-scope="{ node, data }">
                                    <i style="width:12px;display:inline-block;padding-bottom: 2px;vertical-align: middle;" v-if="data.children&&data.children.length===0"></i>
                                    <i style="font-size:12px;padding-bottom: 2px;vertical-align: middle;" v-if="data.children&&data.children.length>0&&!node.expanded" class="el-icon-arrow-right"/>
                                    <i style="font-size:12px;padding-bottom: 2px;vertical-align: middle;" v-if="node.expanded" class="el-icon-arrow-down"/>
                                    <span style="margin-left: 5px;width:100%;display:inline-block;font-size:14px" :title='data.label || "-"' class="tree-node-label" :class="treeNodeCssActive(data.value)" @click.stop.prevent="clickTreeNode(data, $event)" @mousedown.stop>{{data.label}}</span>
                                </span>
                        </el-tree>
                    </div>
                </el-col>
                <el-col class="list">
                    <!--<el-tabs v-model="activeTab" @tab-click="handleClick" v-if="tabsflag">
                        <el-tab-pane :label="item.categoryName" :name="''+item.categoryId" v-for="(item,index) in tabs" :key="index"></el-tab-pane>
                    </el-tabs>-->
                    <!-- <div class="goods_where" v-show="showDIV&&filter_list.length>0">
                        <div v-show="!autoExpend.collapseVisible">
                            <div class="item" v-for="(v1,index) in filter_list.slice(0,4)" :key="'basefitler'+index">
                                <div class="title">{{v1.filterName}}：</div>
                                <div class="list">
                                    <div class="first">
                                        <ul>
                                            <li :class="currentFilterItem(v1.filterId)==0?'red':''" @click="filterItem_change(v1.filterId,0)">不限</li>
                                            <li v-for="(vv1,kk1) in v1.items" :key="kk1" @click="filterItem_change(v1.filterId,vv1.id)" :class="currentFilterItem(v1.filterId)==vv1.id?'red':''">{{vv1.itemName}}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-show="autoExpend.collapseVisible">
                            <div class="item" v-for="(v1,index) in filter_list.slice(0, filter_list.length)" :key="'basefitler'+index">
                                <div class="title">{{v1.filterName}}：</div>
                                <div class="list">
                                    <div class="first">
                                        <ul>
                                            <li :class="currentFilterItem(v1.filterId)==0?'red':''" @click="filterItem_change(v1.filterId,0)">不限</li>
                                            <li v-for="(vv1,kk1) in v1.items" :key="kk1" @click="filterItem_change(v1.filterId,vv1.id)" :class="currentFilterItem(v1.filterId)==vv1.id?'red':''">{{vv1.itemName}}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="more-filter-div" v-if="filter_list.length>0">
                            <div class="left" @click="filterItem_change(0,0)">
                                <i class="el-icon-refresh-left"></i>
                                <div class="more-words">重置条件</div>
                            </div>
                            <div class="right" @click="showCollapse" v-if="autoExpend.more">
                                <i class="el-icon-arrow-down turnDown" v-if="!autoExpend.collapseVisible"></i>
                                <i class="el-icon-arrow-up turnUp" v-if="autoExpend.collapseVisible"></i>
                                <div v-if="!autoExpend.collapseVisible" class="more-words">更多筛选</div>
                                <div v-if="autoExpend.collapseVisible" class="more-words">收起筛选</div>
                            </div>
                        </div>
                    </div> -->
                    <div class="goods_list" v-if="goods_list.length>0">
                        <div class="goods_list_item" v-for="(v3,index) in goods_list" :key="'list'+index">
                            <router-link target="_blank" :to="'/product/detail/'+v3.id">
                                <dl>
                                    <dt><img :src="v3.picUrl" alt="" lazy></dt>
                                    <dd class="title">{{v3.name}}</dd>
                                    <dd class="jianjie">{{v3.brief}}</dd>
                                    <dd><span>查看详情</span></dd>
                                    <!-- <dd><span>立即购买</span><span class="zhekou">{{v.retailPrice}} 折</span></dd> -->
                                </dl>
                            </router-link>
                        </div>
                    </div>
                    <div class="home_empty_list" v-else>
                      <i class="font iconfont">&#xe600;</i>暂无相关数据！
                    </div>
                    <div class="pager_block" style="clear: both;" v-if="goods_list.length>0">
                        <el-pagination @current-change="current_change" background layout="total, prev, pager, next, jumper" :total="total_data" :page-size="page_size" :current-page="current_page"></el-pagination>
                    </div>
              </el-col>
      </el-row>

    </div>
    <!-- footer -->
    <page-footer></page-footer>
  </div>
</template>
<script>
import PageHead from "@/components/public/head.vue"
import PageFooter from "@/components/public/footer.vue"
import useSyncUrl from "../static/synctourl"
import useSyncUrl1 from "../static/synctourl/useSyncUrl1"

export default {
  components: {
    PageHead,
    PageFooter
  },
  props: {},
    data() {
      return {
          expands: [],
          // 是否展开，默认全部展开
          isExpandAll: true,
          // 遮罩层
          loading: true,
          // 重新渲染表格状态
          refreshTable: true,
          categoryList:[],
          brand_list:[],
          purpose_list:[],
          goods_list:[],
          filter_list:[],
          filter_group_arr:[],
          showDIV:false,
          currTreeNodeId: '0',
          props:{
              value:'id',
              label:'name',
              checkStrictly:true
          },
          info:{
            categoryId:0,
            filter:'',
            keyword:'',
            order:'sort',
			asc:'true'
          },
          total_data:0, // 总条数
          page_size:20,
          current_page:1,
          //自动折叠显示更多筛选项
          autoExpend:{
            more:false,
            collapseVisible:false
          },
          typeflag: 'category',
          industryList: [],
          industryInfo: {
            industryId:0,
            categoryId:0,
            filter:'',
            keyword:'',
            order:'sort',
            asc: 'false'
          },
          tabs:[],
          activeTab:'',
          tabsflag: false
      };
    },
    watch: {
        info:{
            handler(){
                if('category' === this.$route.params.type){
                    this.search_goods();
                }
            },
            deep:true
        }
    },
    computed: {
        basefiltersFN:function () {
            return this.filter_list.filter(function (v4,k4){
                if(k4<4){
                    return v4;
                }
            })
        },
        morefiltersFN:function () {
            return this.filter_list.filter(function (v5,k5){
                if(k5>3){
                    return v5;
                }
            })
        }
    },
    methods: {
        _rememberProductScroll() {
            this._productScrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
        },
        showCollapse(){
            // 更多筛选
            this.autoExpend.collapseVisible = !this.autoExpend.collapseVisible
        },
        handleClick(tab) {
            const index = tab.$data.index
            this.filter_list = this.tabs[index].list
            this.goods_list=[]
            this.industryInfo.filter = ''
            this.industryInfo.categoryId = tab.name
            this.get_search_industry()
            this.showDIV = true

            this.filter_group_arr=[]
            for(let i=0;i<this.tabs[index].list.length;i++){
                var newArr = []; 
                newArr[0] = this.tabs[index].list[i].filterId
                newArr[1] = 0
                this.filter_group_arr.push(newArr)
            }
            if(this.tabs[index].list.length>0){
                this.showDIV=true
                        
                if(Object.keys(this.tabs[index].list).length > 4){
                    this.autoExpend.more = true
                    this.autoExpend.hasFilter = true
                }else{
                    this.autoExpend.more = false
                    this.autoExpend.hasFilter = false
                }
            }else{
                this.showDIV=false
            }

            useSyncUrl1({
                    configs: [
                        {
                        name: "industryId",
                        decode: (value) => {
                            this.industryInfo.industryId = value;
                        },
                        encode: () => this.industryInfo.industryId,
                        },
                        {
                        name: "categoryId",
                        decode: (value) => {
                            this.industryInfo.categoryId = value;
                        },
                        encode: () => this.industryInfo.categoryId,
                        }
                    ],
                    onDecodeSuccess: (isPopstate) => {
                       //console.log("onDecodeSuccess", isPopstate);
                    },
                })
        },
        treeNodeCssActive(catId){
            if(this.currTreeNodeId==catId){
                return 'active'
            }else{
                return 'ebutton'
            }
        },
        // 点击树节点事件
        async clickTreeNode(row, event){
            if (event && event.preventDefault) {
                event.preventDefault();
            }
            if (event && event.stopPropagation) {
                event.stopPropagation();
            }
            if (window && window.scrollTo) {
                window.scrollTo({ top: this._productScrollTop || 0, left: window.scrollX || 0, behavior: 'auto' });
            }
            this.currTreeNodeId = row.id || row.value
            //添加标题和meta标签
            document.title = row.categoryName + '-河北科瑞达仪器科技股份有限公司'
            let m = document.querySelectorAll('meta');
            const meta = document.createElement('meta')
            meta.name = 'keywords'
            for(let i=0;i<m.length;i++){
                if (m[i].content == row.categoryName){
                    m[i].remove()
                }
            }
            meta.content = row.categoryName
            m[0].before(meta)
            for(let i=0;i<m.length;i++){
                if(m[i].content =='河北科瑞达仪器科技股份有限公司'){
                    m[i].remove()
                }
            }

            this.goods_list = []
            this.filter_list= []
			this.current_page = 1
            if('category' === this.typeflag){
                this.tabsflag = false
                this.info.filter = ''
                this.currTreeNodeId = row.id
                await this.categoryChange(row.id, false)
                await this.get_category_filters(row.id)
                await this.get_search_where(row.id)

                useSyncUrl1({
                    configs: [
                        {
                        name: "categoryId",
                        decode: (value) => {
                            this.info.categoryId = value;
                        },
                        encode: () => this.info.categoryId,
                        }
                    ],
                    onDecodeSuccess: (isPopstate) => {
                       //console.log("onDecodeSuccess", isPopstate);
                    }
                })
            }else if('industry' === this.typeflag){
                this.tabsflag = true
                this.info.filter = ''
                this.currTreeNodeId = row.value
                this.industryInfo.industryId = row.value
                this.industryInfo.filter = ''
                await this.categoryChange(row.value, true)
                await this.get_industry_filters(row.value)
                await this.get_search_industry(row.value)

                useSyncUrl1({
                    configs: [
                        {
                        name: "industryId",
                        decode: (value) => {
                            this.industryInfo.industryId = value;
                        },
                        encode: () => this.industryInfo.industryId,
                        }
                    ],
                    onDecodeSuccess: (isPopstate) => {
                        //console.log("onDecodeSuccess", isPopstate);
                    },
                })
            }
        },
        //  获取商品分类列表 选择商品
        async get_category_list(){
            await this.$get(this.$api.getProductCategoryTree).then(res=>{
                this.categoryList = res.data&&res.data[0].children
                this.loading = false
            });
        },
        // 选择分类的选择框改变
        categoryChange(categoryId, flag){
            if(flag){
                this.$router.push({ path:"/product/"+this.typeflag, query:{industryId:categoryId}}).catch(err => {err});//zyf增加异常处理
            }else{
                this.$router.push({ path:"/product/"+this.typeflag, query:{categoryId:categoryId}}).catch(err => {err});//zyf增加异常处理
            }
        },
        async get_industry_filters(cid){
            this.tabs = []
            await this.$get(this.$api.getIndustryRelationTree+cid).then(res=>{
                if(res.code===0){
                    this.tabs = res.data
                    this.activeTab = res.data[0]?''+ res.data[0].categoryId:''
                    this.industryInfo.categoryId = res.data[0]?''+ res.data[0].categoryId:''
                    this.filter_list = this.tabs[0]?this.tabs[0].list:[]
                    this.showDIV = true
                    this.filter_group_arr=[]
                    if(this.tabs[0]&&this.tabs[0].list.length>0){
                        for(let i=0;i<this.tabs[0].list.length;i++){
                            let newArr = []; 
                            newArr[0] = this.tabs[0].list[i].filterId
                            newArr[1] = 0
                            this.filter_group_arr.push(newArr)
                        }
                    }
                    
                    if(this.tabs[0]&&this.tabs[0].list.length>0){
                        this.showDIV=true
                        
                        if(Object.keys(this.tabs[0].list).length > 4){
                            this.autoExpend.more = true
                            this.autoExpend.hasFilter = true
                        }else{
                            this.autoExpend.more = false
                            this.autoExpend.hasFilter = false
                        }
                    }else{
                        this.showDIV=false
                    }
                }
            });
        },
        async get_category_filters(cid){
            this.filter_list = []
            await this.$get(this.$api.getProductCategoryFilterList+cid).then(res=>{
                if(res.data!=undefined && res.data!=null && res.data!=''){
                    this.filter_list = res.data;

                    this.filter_group_arr=[]
                    for(let i=0;i<this.filter_list.length;i++){
                      var newArr = []; 
                      newArr[0] = this.filter_list[i].filterId
                      newArr[1] = 0
                      this.filter_group_arr.push(newArr)
                    }
                    if(this.filter_list.length>0){
                        this.showDIV=true
                        
                        if(Object.keys(this.filter_list).length > 4){
                            this.autoExpend.more = true
                            this.autoExpend.hasFilter = true
                        }else{
                            this.autoExpend.more = false
                            this.autoExpend.hasFilter = false
                        }
                    }else{
                        this.showDIV=false
                    }
                }
            });
        },

        //  筛选条件切换事件
        filterItem_change:function(filterId,itemId){
            if('industry' === this.typeflag){
                this.current_page = 1

                if(filterId==0 && itemId==0){
                    for(let i=0;i<this.filter_group_arr.length;i++){
                        this.filter_group_arr[i][1]=0;
                    }
                    this.industryInfo.filter="";
                }else{
                    let filterArr = []
                    this.industryInfo.filter =''
                    
                    for(let i=0;i<this.filter_group_arr.length;i++){
                        if(this.filter_group_arr[i][0]==filterId){
                            this.filter_group_arr[i][1] = itemId
                        }
                        if(this.filter_group_arr[i][1]>0){
                            filterArr.push(this.filter_group_arr[i][1])
                        }
                    }
                    this.industryInfo.filter=filterArr.join('_')
                    this.industryInfo.filter=this.industryInfo.filter.replace('__','_')
                    
                }
                useSyncUrl1({
                    configs: [
                        {
                        name: "industryId",
                        decode: (value) => {
                            this.industryInfo.industryId = value;
                        },
                        encode: () => this.industryInfo.industryId,
                        },
                        {
                        name: "categoryId",
                        decode: (value) => {
                            this.industryInfo.categoryId = value;
                        },
                        encode: () => this.industryInfo.categoryId,
                        },
                        {
                        name: "filter",
                        decode: (value) => {
                            this.industryInfo.filter = value;
                        },
                        encode: () => {
                        return this.industryInfo.filter
                        },
                        }
                    ],
                    onDecodeSuccess: (isPopstate) => {
                        //console.log("onDecodeSuccess", isPopstate);
                    },
                })

                this.get_search_industry()
            }else if('category' === this.typeflag){
                if(filterId==0 && itemId==0){
                    for(let i=0;i<this.filter_group_arr.length;i++){
                        this.filter_group_arr[i][1]=0;
                    }
                    this.info.filter="";
                }else{
                    let filterArr = []
                    this.info.filter =''
                    for(let i=0;i<this.filter_group_arr.length;i++){
                    if(this.filter_group_arr[i][0]==filterId){
                        this.filter_group_arr[i][1] = itemId
                        }
                        if(this.filter_group_arr[i][1]>0){
                        filterArr.push(this.filter_group_arr[i][1])
                        }
                    }
                    this.info.filter=filterArr.join('_')
                    this.info.filter=this.info.filter.replace('__','_')
                }
                
                useSyncUrl1({
                    configs: [
                        {
                        name: "categoryId",
                        decode: (value) => {
                            this.info.categoryId = value;
                        },
                        encode: () => this.info.categoryId,
                        },
                        {
                        name: "filter",
                        decode: (value) => {
                            this.info.filter = value;
                        },
                        encode: () => {
                        return this.info.filter
                        },
                        }
                    ],
                    onDecodeSuccess: (isPopstate) => {
                        //console.log("onDecodeSuccess", isPopstate);
                    },
                })
                this.search_goods();
            }
            
        },
        currentFilterItem:function(filterId){
            for(let i=0;i<this.filter_group_arr.length;i++){
                if(this.filter_group_arr[i][0]==filterId){
                    return this.filter_group_arr[i][1]
                }
            }
        },
        
        // 获取品牌信息
        get_brand_list:function(){
            this.$get(this.$api.getBrandList).then(res=>{
                this.brand_list = res.data.list;
            });
        },
        
        // 获取品牌信息
        get_purpose_list:function(){
            this.$get(this.$api.getPurposeList).then(res=>{
                this.purpose_list = res.data.list;
            });
        },

        goods_sort_click:function(e){
            // 是否取反
            if(e == this.info.goods_type){
                if(this.info.order_type == 0){
                    this.info.order_type = 1;
                }else{
                    this.info.order_type = 0;
                }
            }else{ // 新条件先倒叙
                this.info.goods_type = e;
                this.info.order_type = 0;
            }
        },
        // 搜索指定产品
        search_goods(){
            this.info.page = this.current_page;
            this.info.limit = this.page_size
            //console.log(this.info)
            this.$get(this.$api.searchProductByCategory,this.info).then(res=>{
                if(res!=undefined && res!=null){
                    this.total_data = res.totalrecords;
                    this.goods_list = res.list;
                }
            }).catch(err => {err});
        },
        // 子组件执行搜索
        to_search:function(e){
            //this.info.keyword = e.keywords;
            this.search_goods_by_keywords(e.keywords);
            //this.search_goods();
        },
        // 分页改变
        current_change:function(e){
            this.current_page = e;
            if('category' === this.typeflag){
                this.search_goods();
            }else if('industry' === this.typeflag){
                this.get_search_industry()
            }
        },
        // 根据行业类别筛选产品
        async get_search_industry(route_info){
            if(route_info){
                this.industryInfo.industryId = Number(route_info);
            }
            this.industryInfo.page = this.current_page;
            this.industryInfo.limit = this.page_size
            await this.$get(this.$api.getProductIndustryList, this.industryInfo).then(res=>{
                if(res!=undefined && res!=null){
                    this.total_data = res.data.totalrecords;
                    this.goods_list = res.data.list;
                }
            }).catch(err => {err});
        },
        get_search_where:function(route_info=""){
            let params = this.$route.query.categoryId;
            
            if(route_info !=''){
                params = route_info;
            }
            this.info.categoryId = params; //此处为改造后/product/166 的 166

            this.search_goods();
        },
        async get_industry_list(){
            await this.$get(this.$api.getProductIndustryTree).then(res=>{
                this.industryList = res.data.industryList
                this.loading = false
            });
        },
        changetype(param){
            this.current_page = 1
            this.filter_list = []
            if('category' === param.name){
                this.tabsflag = false
                this.typeflag = 'category'
                this.info.categoryId = 0
                this.info.filter = ''
                this.get_category_list();
                this.get_category_filters(0)
                this.search_goods()
            }else if('industry' === param.name){
                this.tabsflag = true
                this.typeflag = 'industry'
                this.industryInfo.categoryId = 0
                this.get_industry_list()
                this.get_industry_filters(0)
                this.get_search_industry(0)
            }
        }
    },
    async created() {
        let arr = ['首页','产品中心','解决方案','客户案例','新闻动态','人才招聘','关于我们','联系我们']
        document.title='产品中心-河北科瑞达仪器科技股份有限公司'
        let m = document.querySelectorAll('meta');
        const meta = document.createElement('meta')
        meta.name = 'keywords'
        for(let i=0;i<m.length;i++){
            // if(m[i].content =='产品中心'){
            //     m[i].remove()
            // }
            arr.some(item => {
                if(item == m[i].content){
                    m[i].remove()
                }
            })
        }
        meta.content = '产品中心'
        
        m[0].after(meta)
        for(let i=0;i<m.length;i++){
            if(m[i].content =='河北科瑞达仪器科技股份有限公司'){
                m[i].remove()
            }
        }
        

        this.goods_list = []
        this.filter_list = []
        if('industry' === this.$route.params.type){
            this.typeflag = 'industry'
            await this.get_industry_list()

            //  从路由地址的industryId取值
            await this.get_industry_filters(this.$route.query.industryId);
            //  获取行业分类下的对应产品列表
            await this.get_search_industry();

            useSyncUrl({
                configs: [
                    {
                    name: "industryId",
                    decode: (value) => {
                        this.industryInfo.industryId = value;
                    },
                    encode: () => this.industryInfo.industryId,
                    },
                    {
                    name: "categoryId",
                    decode: (value) => {
                        this.industryInfo.categoryId = value;
                        this.activeTab = value
                    },
                    encode: () => this.industryInfo.categoryId,
                    },
                    {
                    name: "filter",
                    decode: (value) => {
                        this.industryInfo.filter = value;

                        this.showDIV = true
                        this.tabsflag = true

                        if(this.industryInfo.categoryId){
                            const res = this.tabs.find(item=>{ return ''+item.categoryId === ''+this.industryInfo.categoryId })
                            this.filter_list = res.list&&res.list.length>0?res.list:[]
                            this.filter_group_arr = []
                            if(value){
                                value.split('_').forEach((item, index)=>{
                                    this.filter_list[index].items.forEach(item2=>{
                                        this.filter_list[index].checkedId = item
                                    })
                                    this.filter_group_arr.push([this.filter_list[index].filterId, 0])
                                    this.filterItem_change(this.filter_list[index].filterId, Number(this.filter_list[index].checkedId))
                                })

                                // 判断筛选条件的大小是否超过了最大长度，超过出现点击展开收起更多
                                let len = value.split('_').length
                                const length = this.filter_list.length
                                if(len < length){
                                    for(let i=len;i<length; i++){
                                        this.filter_group_arr[i] = [this.filter_list[i].filterId, 0]
                                    }
                                }
                                if(Object.keys(this.filter_list).length > 4){
                                    this.autoExpend.more = true
                                    this.autoExpend.hasFilter = true
                                }else{
                                    this.autoExpend.more = false
                                    this.autoExpend.hasFilter = false
                                }
                            }
                        }
                    },
                    encode: () => {
                       return this.industryInfo.filter
                    },
                    }
                ],
                onDecodeSuccess: (isPopstate) => {
                    //console.log("onDecodeSuccess", isPopstate);
                },
            })
        }else{
            this.typeflag='category'
            await this.get_category_list();
            //  从路由地址的categoryId取值
            if(this.$route.query.categoryId){
                await this.get_category_filters(this.$route.query.categoryId);
            }
            
            //  获取产品分类下的产品分类列表
            await this.get_search_where();
            if(this.$route.query.categoryId){
                useSyncUrl({
                configs: [
                    {
                    name: "categoryId",
                    decode: (value) => {
                        this.info.categoryId = value;
                        this.currTreeNodeId = value
                    },
                    encode: () => this.info.categoryId,
                    },
                    {
                    name: "filter",
                    decode: (value) => {
                        this.info.filter = value;
                        if(value){
                            value.split('_').forEach((item, index)=>{
                                this.filter_list[index].items.forEach(items=>{
                                    this.filter_list[index].checkedId = item
                                })
                                this.filterItem_change(this.filter_list[index].filterId, Number(this.filter_list[index].checkedId))
                            })

                            // 判断筛选条件的大小是否超过了最大长度，超过出现点击展开收起更多
                            let len = value.split('_').length
                            const length = this.filter_list.length
                            if(len < length){
                                for(let i=len;i<length; i++){
                                    this.filter_group_arr[i] = [this.filter_list[i].filterId, 0]
                                }
                            }
                            if(Object.keys(this.filter_list).length > 4){
                                this.autoExpend.more = true
                                this.autoExpend.hasFilter = true
                            }else{
                                this.autoExpend.more = false
                                this.autoExpend.hasFilter = false
                            }
                        }
                    },
                    encode: () => {
                       return this.info.filter
                    },
                    }
                ],
                onDecodeSuccess: (isPopstate) => {
                    //console.log("onDecodeSuccess", isPopstate);
                },
            })
            }
        }
    },
    // beforeRouteUpdate:function(to, from, next) {
    //     if(to.path != from.path){
    //        this.get_search_where(to.params.info);
    //     }
    //     // don't forget to call next()
    //     next();
    // },
    mounted() {
        this._productScrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
        window.addEventListener('scroll', this._rememberProductScroll, { passive: true });
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this._rememberProductScroll);
    },
    destroyed(){
       window.removeEventListener("popstate", ()=>{ return true});
    },
};
</script>

<style lang="scss" scoped>
/deep/ .more{
    float: none;
}
/deep/ .el-pagination__jump{
    margin-left: 10px;
}
#product-center{
    min-width: 1100px;
    overflow-x: auto;
}
.container{
    min-width: 1100px;
    width:1280px;
    .el-row{
        justify-content: flex-start;
    }
    .type{
        width:280px;
        /deep/ .left-sidebar button{
            max-width: 250px;
        }
        margin-right: 20px;
    }
    .list{
        max-width:calc(100% - 300px);
        :deep(.el-tabs__nav-scroll){
            padding-left: 15px;
        }
    }
}
/*--------------------------------------------------------------
# Hero Section
--------------------------------------------------------------*/
#product-hero {
    width: 100%;
    height: 45vh;
    background: url("~@/static/img/banner/product-banner.jpg");
    background-size: cover;
    position: relative;
}

// a {cursor:pointer;color:blue;}
// a:link {text-decoration:none;color:blue;}
// a:hover {text-decoration:none;color:red;}
// a:active {text-decoration:none;color:red;background: #c7f2fa;}
// a:visited {text-decoration:none;color:black;}
// .width905{
//     width: 905px;
// }
.el-table th{
    background: #023dfd;
  }
.ebutton {
    color: #1c242c;
    //background-color:#f2f6fc;
    border: none;
    font-size: 14px;
  &:hover {
  color: #0570fd;
   background-color: rgb(242,246,252);
  }
  &:active {
    color: #0871fa;
   background-color: rgb(242,246,252);
  }
}
.active {
    font-size: 14px;
    color: blue;
    padding: 5px;
}
.goods_where{
        border: 1px solid #efefef;
        padding: 10px 10px 0;
        line-height: 45px;
        font-size: 12px;
        background-color: #ffffff;
        margin: 0 0 20px 0;
        .item{
            padding:5px 15px 5px 15px;
            box-sizing: border-box;
            border-bottom: 1px solid #efefef;
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;
            &:last-child{
                border-bottom: none;
            }
            &:after{
                clear:both;
                display: block;
                content:'';
            }
            .title{
                float: left;
                font-size: 14px;
                font-weight: 600;
                margin-right: 10px;
                flex-shrink: 0;
            }
            .list{
                max-width: none;
                
                ul li{
                    pointer-events: auto;
                    cursor: pointer;
                }
                .first{
                    &:after{
                        clear: both;
                        display: block;
                        content:'';
                    }
                    ul li{
                        background: #efefef;
                        line-height: 25px;
                        padding:0 8px;
                        margin-top: 10px;
                        margin-bottom: 10px;
                        text-align: center;
                        float: left;
                        margin-right: 15px;
                        border-radius: 3px;
                        &:hover{
                            color:#fff;
                            background-color:#0f56ff;
                        }
                        &.red{
                            color:#fff;
                            background-color:#0f56ff;
                        }
                    }
                }
                .sec{
                    &:after{
                        clear: both;
                        display: block;
                        content:'';
                    }
                    ul{
                        border-top: 1px dashed #e1e1e1;
                        padding: 10px;
                        margin-top: 15px;
                        &:after{
                            clear:both;
                            display: block;
                            content:'';
                        }
                    }
                    ul li{
                        background: #efefef;
                        float: left;
                        margin-right: 15px;
                        margin-bottom: 10px;
                        padding:0 10px;
                        line-height: 25px;
                        color: #666;
                        font-size: 12px;
                        border-radius: 3px;
                        &:hover{
                            color:#fff;
                            background-color:#f7683c;
                        }
                        &.red{
                            color:#fff;
                            background-color:#f7683c;
                        }
                    }
                    
                }
                .other{
                    ul li{
                        float: left;
                        margin-right: 10px;
                        padding:0 10px;
                        position: relative;
                        &:hover{
                            color:#ca151e;
                        }
                        &.red{
                            color:#ca151e;
                        }
                        .sorts{
                            position: absolute;
                            top:0;
                            right: 0;
                            color:#666;
                            .caret{
                                font-size: 12px;
                                position: absolute;
                                -webkit-transform-origin-x: 0; //缩小后文字居左
                                -webkit-transform: scale(0.80);   //关键
                                &:first-child{
                                    top:16px;
                                    right:-5px;
                                }
                                &:last-child{
                                    top:22px;
                                    right:-5px;
                                }
                                &.red{
                                    color:#ca151e;
                                }
                            }
                        }

                    }
                }
            }
        }
        // 更多筛选
        .more-filter-div{
            width: 100%;
          text-align: center;
          margin: 0 auto;
          height:40px !important;
          display:flex;
          justify-content: center;
          align-items: center;
        }
        .left{
            margin-right: 20px;
            height:100% !important;
            display: flex;
            justify-content: center;
            align-items: center;
            height: 24px;
          cursor: pointer;
          color: #5d08fa;
          .more-words{
            height:24px;
            line-height: 24px;
          }
          i{
            color: #5d08fa;
            margin-right: 5px;
          }
        }
        .right{
          float: left;
          height: 24px;
          display: flex;
          align-items: center;
          cursor: pointer;
          color: #5d08fa;
          i{
            color: #5d08fa;
            margin-right: 5px;
          }
        }
    }
.goods_sort_top{
    position: relative;
    margin:0 auto;
    color:#666;
    i{
        position: absolute;
        right: -16px;
        font-size: 12px;
    }
}
.goods_sort_bottom{
    position: relative;
    color:#666;
    i{
        position: absolute;
        right: -16px;
        font-size: 12px;
    }
}
.line-height-50{
    line-height: 50px;
}
.mbx{
    margin:30px auto;
}

.goods_list{
    padding-left: 0;
    .goods_list_item{
        float: left;
        width: calc(25% - 8px);
        height: 364px;
        background-color: #fefefe;
        box-sizing: border-box;
        margin: 0 10px 10px 0;
        //border-radius: 8px;
        // border: 1px solid #dcdcdc;
        dl{
            width:100% !important;
            border: 1px solid #efefef;
            box-sizing: border-box;
            width: calc(25% - 8px);
            height: 354px;
            -webkit-transition: all .2s linear;
            transition: all .2s linear;
            .el-image{
                width: 180px;
                height: 180px;
                margin:30px auto 25px auto;
                display: block;
            }
        }
        dl dt img{
            height: 180px;
            width: 215px;
            object-fit: contain;
            margin: 30px auto 25px auto;
            display: block;
        }
        dl dd{
            font-size: 12px;
        }
        dl dd.title{
            color: #000;
            height: 36px;
            line-height: 20px;
            text-align: center;
            padding: 0 15px;
            overflow: hidden;
        }
        dl dd.price {
            color: #e01d20;
            line-height: 50px;
            text-align: center;
            padding: 0 15px;
            font-size: 14px;
            overflow: hidden;
        }
        dl dd.jianjie {
            color: #999999;
            line-height: 28px;
            text-align: center;
            padding: 0 15px;
            font-size: 12px;
            height: 38px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
        dl dd span:first-child{
            box-sizing: border-box;
            color: #000;
            background: #f1f8fd;
        }
        dl dd span:first-child:hover{
            color:#fff;
            background: #033cf7;
            width: 100%;
            line-height: 44px;
        }
        dl dd span{
            width: 100%;
            display: block;
            // border-top: 1px solid #efefef;
            float: left;
            line-height: 43px;
            text-align: center;
        }
        dl dd span.retailPrice {
            font-size: 14px;
            color:#b0b0b0;
            text-decoration: line-through;
        }
        dl dd span.zhekou {
            font-size: 14px;
            color:rgb(56, 56, 56);
            //background-color: #f74008;
        }
        dl dd span.zhekou:hover{
            color:#fff;
            background: #033cf7;
        }
    }
    .goods_list_item:nth-of-type(4n){
        margin-right: 0;
    }
    .goods_list_item:hover dl{
        -webkit-transform: translateY(-3px);
        transform: translateY(-3px);
        -webkit-box-shadow: 10px 10px 10px #999;
        box-shadow: 10px 10px 10px #999;
    }
}

/* 选中某行时的背景色*/
.el-table /deep/.el-table__body tr.current-row > td {
  background-color: #92cbf1 !important;
}

/*鼠标移入某行时的背景色*/
.el-table /deep/ .el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: #CFCFCF;
}
/deep/ .el-tree-node__content{
    line-height: 40px;
    height:40px;
    font-size:15px
}
.el-tree{
    margin-top: 7px;
}
.left-sidebar{
    padding: 10px 10px 20px 5px;
    >:first-child{
        display:flex;
        justify-content: flex-start;
        align-items: center;
        font-size: 16px;
        color:#555;
        font-family: 'Microsoft YaHei';
        padding-left: 10px;
        .active{
            color:#033cf7;
            font-size: 16px;
            background: none;
        }
    }
}
:deep(.el-tabs__header){
    margin: 0
}
:deep(.el-tabs){
    width:100%
}
:deep(.el-tabs__item){
    padding: 0 10px;
    font-weight: bold;
}
:deep(.el-tabs__item.is-active){
	color: #0f56ff;
}
:deep(.el-tabs__active-bar){
	background: #0f56ff;
}
.custom-tree-node{
    width:100%
}
.container{
    padding-top:50px;
    margin:0 auto
}
.pager_block /deep/ .el-pagination__total{
    margin-left: 20px !important;
}
</style>
